import I18n from '../../../config/i18n';
import Format from '../../../utils/Formatter';
import './AlternativePrices.css';

interface AlternativePricesProps {
  loading: boolean;
  alternativePrices: {
    price: number;
    arrival: moment.Moment | string;
    departure: moment.Moment | string;
  }[];
  additionToMatchingPrice: boolean;
}

export default function AlternativePrices({
  loading,
  alternativePrices,
  additionToMatchingPrice,
}: AlternativePricesProps): JSX.Element {
  if (loading || !alternativePrices) {
    return <div className="price alt-prices" />;
  }

  return (
    <div className="price alt-prices">
      {additionToMatchingPrice ? I18n.t('price.alternatives') : I18n.t('price.available_dates')}
      {alternativePrices.slice(0, 2).map((altPrice) => (
        <div className="alt-prices-row" key={[altPrice.arrival, altPrice.departure].join('-')}>
          <div>
            {Format.dateMonthShort(altPrice.arrival)}–{Format.dateMonthShort(altPrice.departure)}
          </div>
          <div className="alt-prices-price">{I18n.l('currency', altPrice.price)}</div>
        </div>
      ))}
    </div>
  );
}
